import { useCallback, useEffect, useState } from 'react';

interface UseOnlineModeProps {
  defaultOnline: boolean;
  locationInputRef: React.RefObject<HTMLInputElement>;
  onUpdateOnline?: (online: boolean) => void;
  setDisplayError: (error: boolean) => void;
  setLocation: (location: any) => void;
}

interface UseOnlineModeReturn {
  isOnlineChecked: boolean;
  updateOnline: (online: boolean) => void;
}

export const useOnlineMode = ({
  defaultOnline,
  onUpdateOnline,
  setDisplayError,
  setLocation,
  locationInputRef,
}: UseOnlineModeProps): UseOnlineModeReturn => {
  const [isOnlineChecked, setIsOnlineChecked] = useState(defaultOnline);

  const updateOnline = useCallback(
    (onlineSelected: boolean) => {
      if (onUpdateOnline) {
        onUpdateOnline(onlineSelected);
      }

      setIsOnlineChecked(onlineSelected);

      if (onlineSelected) {
        setDisplayError(false);
        setLocation({});
        if (locationInputRef.current) {
          locationInputRef.current.value = '';
        }
      }
    },
    [onUpdateOnline, setDisplayError, setLocation, locationInputRef],
  );

  // Handle defaultOnline changes
  useEffect(() => {
    setIsOnlineChecked(defaultOnline);
  }, [defaultOnline]);

  return {
    isOnlineChecked,
    updateOnline,
  };
};
